import countries from '../data/country.json'
import { Field, Form, useFormState } from 'react-final-form';
import { FloatLabel } from 'primereact/floatlabel';
import { classNames } from 'primereact/utils';
import OccupancyRate from './OccupancyRate';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
const ChapitreRegion = ({ labels, isFormFieldValid, getFormErrorMessage, familyMember, busLines, chapitres }) => {
    const { values } = useFormState();
    return <Field name={"chapitreRegion"} render={({ input, meta }) => {
        return (
            <div className='field'>
                <FloatLabel>
                    <div className="p-inputgroup flex">
                        <Dropdown
                            scrollHeight="300px"
                            {...{
                                ...input,
                                value: (!familyMember.busLine || values['otherThanBus']) ? values['chapitreRegion'] : familyMember.busLine
                            }
                            }
                            placeholder={labels.chapitreRegion}
                            optionLabel="name"
                            optionValue="name"
                            optionGroupLabel="reg_name"
                            optionGroupChildren={['lines']}
                            disabled={familyMember.takesBus && familyMember.busLine && !values['otherThanBus']}
                            options={
                                Object.entries(busLines.reduce((acc, line) => {
                                    const key = line.country;
                                    if (!acc[key]) acc[key] = [];
                                    if(chapitres.find(chapitre => chapitre.regions.includes(line.name)))
                                        acc[key].push(line);
                                    return acc;
                                }, {}))
                                    .map(entry => { return { 'reg_name': countries[entry[0]].emoji, 'lines': entry[1] }; })
                            }
                            className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                        />
                        {
                            familyMember.takesBus &&
                            familyMember.busLine &&
                            (<>
                                <Field name={"otherThanBus"}
                                    type="checkbox"
                                    render={({ input, meta }) => (
                                        <span className="p-inputgroup-addon">
                                            {labels.other} &nbsp;
                                            <Checkbox
                                                tooltip={labels.otherThanBus}
                                                {...input}
                                            />
                                        </span>
                                    )} />
                            </>
                            )
                        }

                    </div>
                    <label className={classNames({ 'p-error': isFormFieldValid(meta) })}>
                        {labels.chapitreRegion}
                    </label>
                </FloatLabel>
                {getFormErrorMessage(meta)}
            </div>
        )
    }} />
}
const ChapitreChoice = ({ labels, isFormFieldValid, getFormErrorMessage, familyMember, chapitres, getChapitreData, labelslanguage }) => {
    const { values } = useFormState();
    return <Field name={"chapitre"} render={({ input, meta }) => {
        const chapitre = values.chapitre ? getChapitreData(values.chapitre) : {};
        const currentpeople = parseFloat(chapitre.totalPeople) || 0;
        const maxpeople = parseFloat(chapitre.maxPeople) || 0;
        return (<>
            <div className="field">
                <FloatLabel>
                    <Dropdown
                        {...input}
                        scrollHeight="300px"
                        placeholder={labels.chapitre}
                        options={
                            chapitres
                                .filter((chapitre, index) => chapitre.regions.includes(
                                    ((!familyMember.takesBus || values['otherThanBus']) ?
                                        values['chapitreRegion'] :
                                        familyMember.busLine)
                                )
                                )
                                .map(chapitre => chapitre.name)
                        }
                        className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                    />
                    <label className={classNames({ 'p-error': isFormFieldValid(meta) })}>
                        {labels.chapitre}
                    </label>
                </FloatLabel>
                {getFormErrorMessage(meta)}
            </div>
            {OccupancyRate(maxpeople, currentpeople, 0, labels.chapitreOccupancyRate, labels.almostFullWarning)}
        </>
        )
    }} />
}
const Chapitre = ({
    familyMember,
    sfd,
    labels,
    labelslanguage,
    busLines,
    chapitres,
    getChapitreData,
    isFormFieldValid,
    getFormErrorMessage
}) => {

    return <Form onSubmit={(data, form) => {
        for (let key in data)
            familyMember[key] = data[key];
        familyMember.currentStep++;
        sfd(familyMember);
    }}
        initialValues={familyMember}
        validate={(data) => {
            let error = {};
            let requiredFields = ["chapitre"];
            if (data['otherThanBus'])
                requiredFields.push("chapitreRegion");
            for (let f of requiredFields)
                if (!data[f])
                    error[f] = labels['This field is required.'];
            return error;
        }}
        render={({ handleSubmit }) => {
            return (<>
                <div className="grid ui-fluid">
                    <div className="col-12 md:col-6">
                        <ChapitreRegion labels={labels} isFormFieldValid={isFormFieldValid} getFormErrorMessage={getFormErrorMessage} familyMember={familyMember} busLines={busLines} chapitres={chapitres} />
                    </div>
                    <div className="col-12 md:col-6">
                        <ChapitreChoice labels={labels} isFormFieldValid={isFormFieldValid} getFormErrorMessage={getFormErrorMessage} familyMember={familyMember} chapitres={chapitres} getChapitreData={getChapitreData} labelslanguage={labelslanguage} />
                    </div>
                </div>
                <div className="flex py-4 gap-2">
                    <Button
                        type="button"
                        label={labels.back}
                        severity="secondary"
                        icon="pi pi-arrow-left"
                        onClick={() => { familyMember.currentStep--; sfd(familyMember) }} />
                    <Button
                        type="button"
                        label={labels.done}
                        icon="pi pi-check"
                        iconPos="right"
                        onClick={handleSubmit} />
                </div>
            </>)
        }
        } />
}
export default Chapitre;